import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import INSERT_TYPES from "./insertTypes";

/**
 * Two-step modal: pick what to insert, then configure it. Full-screen on phones so the
 * media grid and settings have room; a regular dialog otherwise.
 */
const InsertContentDialog = ({ open, onClose, onInsert }) => {
  const [typeId, setTypeId] = useState(null);
  const fullScreen = useMediaQuery("(max-width:700px)");

  // Always reopen on the menu.
  useEffect(() => {
    if (open) setTypeId(null);
  }, [open]);

  const type = INSERT_TYPES.find((t) => t.id === typeId) || null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { bgcolor: "#1b2736", backgroundImage: "none" } }}
      data-testid="insert-content-dialog"
    >
      <DialogTitle sx={{ pr: 7 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {type && (
            <IconButton
              size="small"
              onClick={() => setTypeId(null)}
              aria-label="Back to insert menu"
              edge="start"
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
          <span>{type ? type.label : "Insert content"}</span>
        </Stack>
        <IconButton
          onClick={onClose}
          aria-label="Close"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: { xs: 2, sm: 3 } }}>
        {type ? (
          <type.Component onInsert={onInsert} onCancel={() => setTypeId(null)} />
        ) : (
          <List disablePadding>
            {INSERT_TYPES.map((item) => (
              <ListItemButton
                key={item.id}
                onClick={() => setTypeId(item.id)}
                sx={{ borderRadius: 1, mb: 0.5 }}
                data-testid={`insert-type-${item.id}`}
              >
                <ListItemText
                  primary={item.label}
                  secondary={
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      {item.description}
                    </Typography>
                  }
                />
              </ListItemButton>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default InsertContentDialog;
